/*
 * @Descripttion:
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-10 14:24:00
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-11 10:22:31
 * @changeLog:
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Sphere/interface.ts
 */

// ./interface.ts
import type { Mesh } from '@anov/3d-core'
import type { options } from './types'

export interface ISphere {
  /** 创建球体 */
  createSphere: (options: options) => Mesh
  /** 更新球体 */
  updateSphere: (options: options) => void
  /** 销毁球体 */
  destroy: () => void
}
